"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("@lingui/react");

var _react2 = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _blocks = require("@bueno/blocks");

var _reactRouter = require("react-router");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _NoResultsOverlay = _interopRequireDefault(require("../NoResultsOverlay"));

var _ToggleSnoozed = _interopRequireDefault(require("../../containers/ToggleSnoozed"));

var _InfoText = _interopRequireDefault(require("./components/InfoText"));

var _EquipHeader = _interopRequireDefault(require("./components/EquipHeader"));

var _EquipRow = _interopRequireDefault(require("./components/EquipRow"));

var _EquipActions = _interopRequireDefault(require("./components/EquipActions"));

var _columns = require("../../utils/columns");

var _eventTracking = require("../../utils/eventTracking");

var _ActionModals = require("../ActionModals");

var _context = require("../ActionModals/ViewAction/context");

var _ViewAction = require("../ActionModals/ViewAction");

var _AssociateAction = require("../ActionModals/AssociateAction");

var _context2 = require("../ActionModals/AssociateAction/context");

const DEFAULT_ROWS_TO_SHOW = 25;
const GoBack = (0, _styledComponents.default)(_reactRouterDom.Link)`
  text-decoration: none;
`;
const SEARCH_KEY = 'equipsSearch';
const StyledBody = (0, _styledComponents.default)(_blocks.Body)`
  color: ${_blocks.palette.neutral8};
`;
const StyledThirds = (0, _styledComponents.default)(_blocks.Thirds)`
  margin-bottom: ${_blocks.spacing.default};
`;
const StyledFrame = (0, _styledComponents.default)(_blocks.Frame)`
  position: relative;
  overflow: visible;
`;
const StyledDataGrid = (0, _styledComponents.default)(_blocks.DataGrid)`
  overflow: visible;
`;

function calcAllSelected(visible, selected) {
  const selectableIds = visible.filter(row => row.issueKey == null).map(row => row.equipRuleId); // If there's nothing to select...

  if (selectableIds.length < 1) return false; // Otherwise, check whether each selectable row equipRuleId
  // already exists in state.selected.  If it does, return true, otherwise return false.

  return selectableIds.reduce((isSelected, id) => {
    if (isSelected === false) return false;
    return selected.has(id);
  }, true);
}

class Equip extends _react2.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleUpdateShowSnoozed", ({
      showSnoozed,
      hits
    }) => {
      const activeHits = showSnoozed ? hits : hits.filter(asset => !asset.isSnoozed);
      this.setState({
        activeHits
      }, () => {
        this.handleUpdateData({
          filtered: activeHits,
          query: this.state.searchString
        }, false);
      });
    });
    (0, _defineProperty2.default)(this, "handleUpdateData", ({
      filtered = [],
      query
    }, trackEvent = true) => {
      // Segment tracking - Searched hits
      if (trackEvent) {
        (0, _eventTracking.searchedEvent)('hits', query);
      }

      if (filtered.length === 0) {
        this.setState({
          noResults: true
        });
        return;
      }

      const sorted = this.sortRows(filtered);
      this.setState(({
        selected = [],
        rowsToShow
      }) => {
        const visible = sorted.slice(0, rowsToShow);
        const isAllSelected = calcAllSelected(visible, selected, filtered);
        return {
          filtered: sorted,
          visible: sorted.slice(0, rowsToShow),
          isAllSelected,
          rowsToShow,
          noResults: false,
          query
        };
      });
    });
    (0, _defineProperty2.default)(this, "handleDisableSelectedAll", () => {
      this.setState({
        isAllSelectedDisabled: true
      });
    });
    (0, _defineProperty2.default)(this, "handleEnableSelectedAll", () => {
      this.setState({
        isAllSelectedDisabled: false
      });
    });
    (0, _defineProperty2.default)(this, "handleSelectAll", () => {
      this.setState(({
        visible,
        selected
      }) => {
        const selectableIds = visible.filter(row => Boolean(row.issueKey) !== true).map(row => row.equipRuleId); // If nothing's selectable, don't allow selectAll

        if (selectableIds.length < 1) {
          return {
            isAllSelected: false
          };
        } // Otherwise, if all are selected, unselect all visible


        const allSelected = calcAllSelected(visible, selected);

        if (allSelected) {
          const clonedSet = new Set(selected);
          selectableIds.forEach(ruleEquipId => {
            clonedSet.delete(ruleEquipId);
          });
          return {
            isAllSelected: false,
            selected: clonedSet
          };
        } // Otherwise, add all visible to selected


        const clonedSet = new Set(selected);
        selectableIds.forEach(id => {
          clonedSet.add(id);
        });
        return {
          isAllSelected: true,
          selected: clonedSet
        };
      });
    });
    (0, _defineProperty2.default)(this, "handleRowSelect", id => () => {
      this.setState(({
        selected,
        visible
      }) => {
        const clonedSet = new Set(selected);

        if (selected.has(id)) {
          clonedSet.delete(id);
        } else {
          clonedSet.add(id);
        }

        return {
          selected: clonedSet,
          isAllSelected: calcAllSelected(visible, clonedSet)
        };
      });
    });
    (0, _defineProperty2.default)(this, "handleShowMore", () => {
      this.setState(state => {
        const updatedRowsToShow = state.rowsToShow + 10;
        return {
          rowsToShow: updatedRowsToShow,
          visible: state.filtered.filter((asset, i) => i < updatedRowsToShow),
          isAllSelected: false
        };
      });
    });
    (0, _defineProperty2.default)(this, "handleShowAll", () => {
      this.setState(state => ({
        visible: [...state.filtered],
        rowsToShow: state.filtered.length,
        isAllSelected: false
      }));
    });
    (0, _defineProperty2.default)(this, "handleAssociate", targetRuleId => (createNew = false) => {
      this.props.showModal({
        selected: [targetRuleId],
        hits: this.state.hits,
        createNew
      });
    });
    (0, _defineProperty2.default)(this, "showCreateActionFromRowAction", (equipRuleId, occurrenceId) => {
      this.setState({
        createActionHits: this.state.hits.filter(h => h.equipRuleId === equipRuleId),
        createActionOpen: true,
        lastClickedModal: occurrenceId
      });
    });
    (0, _defineProperty2.default)(this, "showCreateActionFromCheckbox", () => {
      this.setState({
        createActionHits: this.state.hits.filter(h => this.state.selected.has(h.equipRuleId)),
        createActionOpen: true
      });
    });
    (0, _defineProperty2.default)(this, "hideCreateAction", () => {
      this.setState({
        createActionOpen: false,
        createActionHits: []
      });
    });
    (0, _defineProperty2.default)(this, "handleLastClickedModal", occurrenceId => {
      this.setState({
        lastClickedModal: occurrenceId
      });
    });
    this.state = {
      noResults: false,
      hits: [],
      activeHits: [],
      filtered: [],
      visible: [],
      selected: new Set(),
      isAllSelected: false,
      isAllSelectedDisabled: false,
      // eslint-disable-next-line
      rowsToShow: DEFAULT_ROWS_TO_SHOW,
      snoozedCount: props.hits.filter(rule => rule.isAllSnoozed).length,
      query: undefined,
      lastClickedModal: undefined,
      createActionOpen: false,
      createActionHits: []
    };
  }

  componentDidMount() {
    const {
      showSnoozed,
      hits
    } = this.props;
    const activeHits = showSnoozed ? hits : hits.filter(asset => !asset.isSnoozed); // Track Equip view metrics

    (0, _eventTracking.viewedInsightEvent)(hits);
    this.setState(() => ({
      hits: activeHits || [],
      activeHits,
      filtered: activeHits || [],
      visible: activeHits.filter((asset, i) => i < DEFAULT_ROWS_TO_SHOW),
      rowsToShow: DEFAULT_ROWS_TO_SHOW,
      noResults: activeHits.length === 0,
      snoozedCount: hits.filter(asset => asset.isSnoozed).length
    }));
  }

  componentDidUpdate({
    hits,
    showSnoozed,
    sortOption,
    sortDirection
  }, {
    visible
  }) {
    if (visible !== this.state.visible) {
      const selectableIds = this.state.visible.filter(row => row.issueKey == null).map(row => row.equipRuleId);

      if (selectableIds.length === 0) {
        this.handleDisableSelectedAll();
      } else {
        this.handleEnableSelectedAll();
      }
    } // If the data set has changed, update `hits` in state and clear all selections


    if (hits !== this.props.hits && this.props.hits.length > 0) {
      this.handleSetHits({
        hits: this.props.hits,
        clearSelected: true
      });
    } // If show/hide snooze is toggled, update `hits` in state without clearing selections


    if (showSnoozed !== this.props.showSnoozed) {
      this.handleUpdateShowSnoozed({
        showSnoozed: this.props.showSnoozed,
        hits: this.props.hits
      });
    }

    if (sortOption !== this.props.sortOption || sortDirection !== this.props.sortDirection) {
      this.handleUpdateData({
        query: this.state.searchString,
        filtered: this.state.filtered
      });
    }
  }

  /**
   * Use the library of sort functions defined in the sort by component for all
   * the rules
   * @param {*} rows
   */
  sortRows(rows) {
    const {
      sortOption,
      sortDirection
    } = this.props;
    const column = _columns.equipColumns[sortOption];
    return column.sortFn(rows, sortDirection);
  }

  handleSetHits({
    hits,
    clearSelected = false
  }) {
    const snoozedHits = hits.filter(hit => hit.isSnoozed);
    const activeHits = this.props.showSnoozed ? hits : hits.filter(hit => !hit.isSnoozed);
    this.setState(state => {
      const sorted = this.sortRows(activeHits);
      const selected = clearSelected ? new Set() : state.selected;
      const isAllSelected = clearSelected ? false : state.isAllSelected;
      return {
        hits: sorted,
        filtered: sorted,
        visible: sorted.slice(0, state.rowsToShow),
        snoozedCount: snoozedHits.length,
        selected,
        isAllSelected,
        noResults: sorted.length < 1
      };
    });
  }

  render() {
    const {
      filtered,
      visible,
      selected,
      isAllSelected,
      noResults,
      isAllSelectedDisabled
    } = this.state;
    const filteredCount = filtered.length;
    const visibleCount = visible.length;
    const selectedCount = selected.size;
    const {
      ruleName,
      sortDirection,
      syncoId,
      ruleDescription
    } = this.props;
    return /*#__PURE__*/_react2.default.createElement(_context.ViewActionProvider, null, /*#__PURE__*/_react2.default.createElement(_context2.AssociateActionProvider, null, /*#__PURE__*/_react2.default.createElement(_InfoText.default, {
      ruleName: ruleName,
      ruleDescription: ruleDescription
    }), /*#__PURE__*/_react2.default.createElement(StyledThirds, null, /*#__PURE__*/_react2.default.createElement(_blocks.Left, null, /*#__PURE__*/_react2.default.createElement(GoBack, {
      as: "span",
      onClick: () => {
        window.history.back();
      }
    }, /*#__PURE__*/_react2.default.createElement(_blocks.Back, {
      text: "Back"
    }), " ")), /*#__PURE__*/_react2.default.createElement(_blocks.Center, null, /*#__PURE__*/_react2.default.createElement(_blocks.Search, {
      sessionKey: SEARCH_KEY,
      data: this.state.activeHits,
      initial: this.state.query,
      onSearch: this.handleUpdateData,
      indexId: "occurrenceId",
      defaultField: "targetValueString",
      placeholder: "Filter results e.g. \u2018critical\u2019 or \u2018flat lining\u2019",
      thick: true,
      cy: "Equips-Search"
    })), /*#__PURE__*/_react2.default.createElement(_blocks.Right, null, /*#__PURE__*/_react2.default.createElement(_ToggleSnoozed.default, {
      count: this.state.snoozedCount
    }))), /*#__PURE__*/_react2.default.createElement(StyledFrame, null, selected.size > 0 && /*#__PURE__*/_react2.default.createElement(_EquipActions.default, {
      createTicket: this.showCreateActionFromCheckbox,
      equipRuleIds: [...this.state.selected]
    }), /*#__PURE__*/_react2.default.createElement(StyledDataGrid, {
      group: [{
        start: 1,
        end: 8
      }],
      columns: 8,
      grow: [5],
      cellProps: {
        type: 'dense',
        density: 'default'
      }
    }, /*#__PURE__*/_react2.default.createElement(_EquipHeader.default, {
      onSort: this.props.updateSort,
      activeSort: this.props.sortOption,
      sortDirection: sortDirection,
      filtered: filtered,
      hits: this.state.hits,
      isAllSelected: isAllSelected,
      onSelectAll: this.handleSelectAll,
      isAllSelectedDisabled: isAllSelectedDisabled
    }), noResults && /*#__PURE__*/_react2.default.createElement(_NoResultsOverlay.default, {
      noResultsMessage: true
    }), filtered.length > 0 && visible.map(asset => /*#__PURE__*/_react2.default.createElement(_EquipRow.default, {
      asset: asset,
      isSelected: selected.has(asset.equipRuleId),
      onSelect: this.handleRowSelect(asset.equipRuleId),
      key: asset.equipRuleId,
      showCreateAction: this.showCreateActionFromRowAction,
      onAssociate: this.handleAssociate(asset.targetRuleId),
      lastClickedModal: this.state.lastClickedModal,
      handleLastClickedModal: this.handleLastClickedModal
    })), /*#__PURE__*/_react2.default.createElement(_blocks.DataGridFooter, null, /*#__PURE__*/_react2.default.createElement(StyledBody, null, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "show_more_row.showing_count",
      values: {
        visibleCount: visibleCount,
        filteredCount: filteredCount
      },
      components: {
        0: /*#__PURE__*/_react2.default.createElement("strong", null),
        1: /*#__PURE__*/_react2.default.createElement("strong", null)
      }
    }), "\xA0", selectedCount > 0 && /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "show_more_row.hits_selected",
      values: {
        selectedCount: selectedCount
      }
    })), filteredCount > visibleCount && /*#__PURE__*/_react2.default.createElement(_blocks.Button, {
      appearance: "outline",
      primary: true,
      thin: true,
      onClick: this.handleShowMore
    }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "show_more_row.show_more"
    })), filteredCount > visibleCount && /*#__PURE__*/_react2.default.createElement(_blocks.Button, {
      appearance: "outline",
      primary: true,
      thin: true,
      onClick: this.handleShowAll
    }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "show_more_row.show_all"
    }))))), /*#__PURE__*/_react2.default.createElement(_ViewAction.ViewAction, null), /*#__PURE__*/_react2.default.createElement(_AssociateAction.AssociateAction, {
      ruleName: ruleName,
      syncoId: syncoId,
      hits: this.state.hits
    }), this.state.createActionOpen === true && this.state.createActionHits.length !== 0 && /*#__PURE__*/_react2.default.createElement(_ActionModals.CreateAndAssociate, {
      isOpen: this.state.createActionOpen,
      onRequestClose: this.hideCreateAction,
      hits: this.state.createActionHits
    })));
  }

}

(0, _defineProperty2.default)(Equip, "propTypes", {
  sortOption: _propTypes.default.string.isRequired,
  sortDirection: _propTypes.default.string.isRequired,
  showSnoozed: _propTypes.default.bool
});
(0, _defineProperty2.default)(Equip, "defaultProps", {
  showSnoozed: false
});

var _default = (0, _reactRouter.withRouter)(Equip);

exports.default = _default;
module.exports = exports.default;